'use client';

import Image from 'next/image';
import initMaia from 'components/layout/Header/Maia/maia-chat';

import { FC, useEffect } from 'react';

import IconButton from 'components/ui/IconButtonV2';

const CHAT_BUTTON_ID = 'maia-chat-button';

const Maia: FC = () => {
  useEffect(() => {
    initMaia(CHAT_BUTTON_ID, true, process.env.MAIA_APP_ID, process.env.MAIA_API_HASH, null);
  }, []);

  return (
    <IconButton
      id={CHAT_BUTTON_ID}
      href='https://t.me/arbihunter_support'
      isExternal
      className='mb-[32px] me-[32px] ms-auto p-[16px]'
      icon={<Image src='/icons/common/help.svg' alt='Help Icon' width={24} height={24} />}
    />
    // <IconButton
    //   id={CHAT_BUTTON_ID}
    //   className='mb-[32px] me-[32px] ms-auto p-[16px]'
    //   icon={<Image src='/icons/common/help.svg' alt='Help Icon' width={24} height={24} />}
    // />
  );
};

export default Maia;
